/**
 * Proctoring events for Hogeschooltaal
 */
module.exports = {
  STUDENT_LEAVES_FULL_SCREEN: 'EV-HST-FS-DESACTIVATED',
  STUDENT_GOES_FULL_SCREEN: 'EV-HST-FS-ACTIVATED',
  STUDENT_CURSOR_LEAVES_PAGE: 'EV-HST-CRSR-LEFT',
  STUDENT_CURSOR_RETURNS_PAGE: 'EV-HST-CRSR-RETURNED',
  STUDENT_HAS_APPS_OPENED: 'EV-HST-APPS-OPENED',
  STUDENT_HAS_OTHER_ACTIVE_MONITOR: 'EV-HST-MNTR-ACTIVE',
  SYSTEM_TAKES_PHOTO: 'EV-HST-SYS-PHOTO-TAKEN',
  SYSTEM_TAKES_SCREENSHOT: 'EV-HST-SYS-SCRNSHT-TAKEN',
  TEST_PAGE_LOSES_FOCUS: 'EV-HST-TST-FCS-LOST',
  TEST_PAGE_RECOVERS_FOCUS: 'EV-HST-TST-FCS-RECOVERED',
};
